import styled from 'styled-components'
// @ts-ignore
import InputMask from 'react-input-mask'
import { Slider } from 'antd'
import { colors, device } from 'Styled/variables'

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media ${device.mobileMax} {
    position: relative;
    flex-direction: column-reverse;
  }
`

export const StyledSlider = styled(Slider)<{ value: number; currency: string }>`
  margin: 0;
  width: 100%;

  .ant-slider-rail {
    height: 12px;
    border-radius: 6px;
    background-color: ${colors.greyBg};
    border: 1px solid ${colors.greyStroke};
  }
  .ant-slider-handle {
    position: relative;

    &:before {
      content: '${({ value, currency }) =>
        `${currency} ${Math.ceil(value / 10) * 10}`}';
      position: absolute;
      top: -35px;
      left: -15.5px;
      padding: 4px 12px;
      min-width: 55px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${colors.white};
      color: ${colors.greyTextWhiteBg};
      font-size: 14px;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      opacity: 0;
      white-space: nowrap;
      transition: 0.15s all ease-in-out;
    }

    &:hover,
    &:active {
      &:before {
        opacity: 1;
      }
    }
  }

  .ant-slider-step {
    .ant-slider-dot {
      display: none;
    }
  }
  
  .ant-slider-mark {
    margin-top: 8px;

    @media ${device.mobileMax} {
      left: 4px;
      width: 12px;
    }

    .ant-slider-mark-text {
      color: ${colors.greyTextWhiteBg};
      font-size: 14px;
      transform: none !important;

      &:last-child {
        left: auto !important;
        right: 0;
      }
    }
  }
  &:hover {
    .ant-slider-rail {
      background-color: ${colors.greyBg};
    }
  }

  @media ${device.mobileMax} {
    width: 12px;
    height: 312px;
    /* margin-left: 37px; */

    .ant-slider-rail {
      height: 312px;
      width: 12px;
    }
    .ant-slider-handle {
      position: absolute;

      &:before {
        display: none;
      }
    }

    .ant-slider-mark {
      .ant-slider-mark-text {
        &:first-child {
          bottom: 12px !important;
        }
        &:last-child {
          left: 4px !important;
          right: unset;
          bottom: 10px;
        }

        @media ${device.mobileMax} {
          &:first-child {
              left: 0 !important;
              width: 100%;
              display: flex;
              justify-content: center;
              bottom: 0px !important;
              transform: translateY(16px) !important;
            }
            &:last-child {
              left: 0 !important;
              width: 100%;
              display: flex;
              justify-content: center;
              margin-bottom: 0 !important;
              transform: translateY(-16px) !important;
            }
        }
      }
    }
  }


`

export const InputContainer = styled.div`
  position: relative;
  margin-left: 16px;
  width: 80px;
  height: 47px;
`

export const ValueInput = styled.input`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${colors.mainText};
  border: 1px solid ${colors.greyStroke};
  border-radius: 8px;
  outline: none;

  @media ${device.mobileMax} {
    flex-grow: 1;
    margin-left: 0px;
    margin-bottom: 54px;
    width: 100%;
  }
`

export const InputOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  cursor: text;
`

export const InlineStyles = {
  trackStyle: {
    height: 12,
    borderRadius: 6,
    backgroundColor: colors.green,
  },
  trackStyleMobile: {
    height: 312,
    width: 12,
    borderRadius: 6,
    backgroundColor: colors.green,
  },
  handleStyle: {
    marginTop: -6,
    height: 24,
    width: 24,
    border: 'none',
    borderRadius: 12,
    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.25)',
  },
  handleStyleMobile: {
    marginLeft: -6,
    height: 24,
    width: 24,
    border: 'none',
    borderRadius: 12,
    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.25)',
  },
}
